import { useState } from "react";

export const useSharedState = (
  input: any,
  handler?: (prevState: any) => void
) => {
  const [state, set] = useState(input);
  return [handler ? input : state, handler || set];
};
